var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 80,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("xml-message-list", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.xmlComponent === "XmlMessageList",
                      expression: "xmlComponent === 'XmlMessageList'",
                    },
                  ],
                  attrs: {
                    "quote-id": _vm.quoteId,
                    "message-type": _vm.messageType,
                    "page-size": _vm.pageSize,
                  },
                  on: { view: _vm.viewXml, error: _vm.handleError },
                }),
                _vm.xmlComponent === "XmlViewer"
                  ? _c("xml-viewer", {
                      attrs: {
                        "quote-id": _vm.quoteId,
                        "message-id": _vm.selectedMessageId,
                      },
                      on: { error: _vm.handleError },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _vm.xmlComponent === "XmlViewer"
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary tooltip",
                      attrs: { "data-tooltip": "Go back" },
                      on: {
                        click: function ($event) {
                          return _vm.back()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon is-small" }, [
                        _c("i", {
                          staticClass: "mdi mdi-18px mdi-arrow-left-bold",
                        }),
                      ]),
                      _c("span", [_vm._v("Back")]),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Close viewer" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("span", [_vm._v("Close")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }